export const setPresetData = (items, id, data) => {
    return items.map((item) => {
        return item.id === id ? data : item;
    });
};
